import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/pages/authShared";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe réinitialisé. Vous pouvez vous connecter.");
      nav("/connexion");
    } catch (err) { toast.error(apiError(err)); } finally { setLoading(false); }
  };

  if (!token) return <AuthShell title="Lien invalide"><p className="text-sm text-ink-muted text-center">Ce lien de réinitialisation est invalide. <Link to="/mot-de-passe-oublie" className="text-terracotta underline">Demander un nouveau lien</Link></p></AuthShell>;

  return (
    <AuthShell title="Nouveau mot de passe">
      <form onSubmit={submit} className="space-y-4">
        <div><Label htmlFor="password">Nouveau mot de passe</Label><Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="bg-sand border-line mt-1" data-testid="reset-password" /></div>
        <Button type="submit" disabled={loading} className="w-full bg-terracotta hover:bg-terracotta-dark text-white rounded-md" data-testid="reset-submit">{loading ? "Enregistrement…" : "Réinitialiser"}</Button>
      </form>
    </AuthShell>
  );
}
